export class MobileMenu {
  constructor() {
    $('[data-mobile-menu-toggle]').on('click', function () {
        $('[data-mobile-menu]').slideToggle();
      }
    )
  }
}
